import * as React from "react";
import { useEffect, useCallback, useState, useRef } from "react";
import Spinner from "../../spinner/spinner.component";
import Loader from "./loader.component";

interface PropsInterface {
  children: React.ReactNode;
  isOpen: boolean;
  isLoading: boolean;
  toggleOpen: (value: boolean) => void;
}

const Prompt = ({
  isOpen,
  isLoading,
  toggleOpen,
  children,
}: PropsInterface) => {
  const [onCloseScrollPosiiton, setOnCloseScrollPosiiton] = useState(0);
  const modalRef = useRef<HTMLDivElement>(null);
  const handleEscape = useCallback(
    (event: KeyboardEvent) => {
      if (event.keyCode === 27) {
        toggleOpen(false);
      }
    },
    [toggleOpen]
  );

  const calculateModalPosition = useCallback((): number => {
    if (modalRef?.current) {
      const elementPositionY = modalRef.current.offsetTop;
      const offsetTop =
        (window.innerHeight - modalRef.current.clientHeight * 2) / 2;
      return elementPositionY - offsetTop;
    }
    return 0;
  }, [modalRef]);

  useEffect(() => {
    document.addEventListener("keydown", handleEscape, false);
    return () => {
      document.removeEventListener("keydown", handleEscape, false);
    };
  }, [toggleOpen, handleEscape]);

  useEffect(() => {
    if (isOpen) {
      setOnCloseScrollPosiiton(window.pageYOffset);
      const scrollToPosition = calculateModalPosition();
      window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
    } else {
      window.scrollTo({ top: onCloseScrollPosiiton, behavior: "smooth" });
    }
  }, [isOpen, calculateModalPosition, onCloseScrollPosiiton]);

  return (
    <div
      className={`prompt-overlay flex-container align-items-center space-around ${
        isOpen ? "is-open" : ""
      }`}
      onClick={() => toggleOpen(false)}
    >
      <div
        ref={modalRef}
        className="prompt-modal flex-container align-items-center space-around"
        onClick={(e) => e.stopPropagation()}
      >
        <Loader isVisible={isLoading} classes="prompt-loader" />
        {/* {isLoading && (
          <Spinner customClassName="prompt-loader" layout="qesheq-default" />
        )} */}
        <div className={`prompt-content-wrapper ${isLoading && `is-loading`}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Prompt;
